import { cardSdkSource } from "virtual:html-card-sdk";

/** Insert the compiled SDK before author scripts; pass connection settings as HTML attributes. */
export function buildCardDocument(html: string, instance: string, parentOrigin: string): string {
  const document = new DOMParser().parseFromString(html, "text/html");
  const script = document.createElement("script");
  script.dataset.cardInstance = instance;
  script.dataset.parentOrigin = parentOrigin;
  script.textContent = cardSdkSource;
  document.head.prepend(script);
  return `<!doctype html>\n${document.documentElement.outerHTML}`;
}

/** Data bridge version a card declares with `<meta name="decisively-bridge" content="2">`. Anything else is v1. */
export function getCardBridgeVersion(html: string): 1 | 2 {
  const document = new DOMParser().parseFromString(html, "text/html");
  const meta = document.querySelector('meta[name="decisively-bridge"]');
  return meta?.getAttribute("content")?.trim() === "2" ? 2 : 1;
}
